<template>
	<div class="w1200 flex myinfo">
		<choice-menu></choice-menu>
		<div class="flex flex-direction align-stretch benben-flex-layout myinfo_1">
			<div class="myinfo_2">{{$t('历史订单')}}</div>
			<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
				<div v-if="order_list.length > 0">
				    <template v-for="(item,index) in order_list">
				    	<div class="flex flex-direction align-stretch benben-flex-layout pointer appointment_2" @click="caozuo(1,item)">
				    		<div class="flex appointment_3">
				    			<div class="flex appointment_3_1">{{item.date}}</div>
				    			<div class="flex appointment_3_2" v-if=" item.status=='finish'">{{$t('已完成')}}</div>
				    			<div class="flex appointment_3_2" v-if=" item.status=='unpaid'">{{$t('待支付')}}</div>
				    			<div class="flex appointment_3_2" v-if=" item.status=='sending'">{{$t('待配送')}}</div>
				    			<div class="flex appointment_3_2" v-if=" item.status=='delivery'">{{$t('配送中')}}</div>
				    			<div class="flex appointment_3_2" v-if=" item.status=='cancel'">{{$t('已取消')}}</div>
				    		</div>
							<template v-for='(child,key1) in item.chlid'>
								<div class="flex appointment_4">
									<img class="appointment_4_1" :src='child.thumb' alt="" srcset="">
									<div class="flex-sub flex flex-direction align-stretch justify-between benben-flex-layout appointment_4_2">
										<div class="appointment_4_3">{{child.name}}</div>
										<div class="appointment_4_4">{{child.num}}{{$t('份')}}</div>
									</div>
								</div>
							</template>
				    		
				    	</div>
				    </template>
				</div>
				<div class="myinfo_7 flex flex-direction flex-wrap align-center benben-flex-layout" v-else>
					<img class="myinfo_7_1" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
					<div class="myinfo_7_2">{{$t('暂无预约')}}</div>
					<div class="myinfo_7_3 pointer">{{$t('预订更多')}}</div>
				</div>
				<div v-if="order_list.length > 0" style="text-align: center;margin: 20px  0;">
					<el-pagination
					   @current-change="handleCurrentChange"
					   layout="prev, pager, next"
					   :current-page.sync="page" :page-size="page_size"
					   :total="total">
					 </el-pagination>
				</div>
			</div>
			
			
		</div>
		
	</div>
</template>

<script>
	import ChoiceMenu from "../components/choiceMenu.vue"
	export default {
		components: {
			ChoiceMenu
		},
		data() {
			return {
				total:0,
				page:1,
				page_size:10,
				loading:true,
				order_list:[]
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post68d91ca0dd880()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68d91ca0dd880()
			},
			// 切换页面
			handleCurrentChange(val){
				this.page = val
				this.post68d91ca0dd880()
			},
			post68d91ca0dd880(){
				this.$api.post(this.$apiUrls.post68d91ca0dd880,{page:this.page,list_rows:this.page_size}).then((res) => {
					if(res.code == 1){
						this.order_list = res.data.data
						this.total = res.data.total
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type,item){
				let url = ''
				if(type == 1){
					url = 'orderDetal'
					window.sessionStorage.setItem('order_id', item.aid);
					window.sessionStorage.setItem('order_type', 3);
				}
				this.$router.push({
					name: url,
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.myinfo{
		margin-top: 20px;
	}
	.myinfo_1{
		width: 980px;
		margin: 0 0 0 220px;
		padding:0 20px 100px;
		background: #fff;
		box-sizing: border-box;
	}
	.myinfo_2{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.appointment_2{
		background: #F8F8FA;
		border-radius: 8px 8px 8px 8px;
		padding: 0 16px 16px;
		margin: 20px 0 0 0;
		// width: 786px;
	}
	.appointment_3{
		padding: 16px 0 10px 0;
		border-bottom: 1px solid #E7E7E7;
	}
	.appointment_3_1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.appointment_3_2{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: 0 0 0 auto;
	}
	.appointment_4{
		margin: 16px 0 0 0;
	}
	.appointment_4_1{
		width: 96px;
		height: 96px;
	}
	.appointment_4_2{
		margin: 0 0 0 12px;
		height: 96px;
	}
	.appointment_4_3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.appointment_4_4{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		// margin: auto 0 0 0;
	}
	.myinfo_7{
		padding: 72px 0;
	}
	.myinfo_7_1{
		width: 217px;
		height: 177px;
	}
	.myinfo_7_2{
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}
	.myinfo_7_3{
		height: 42px;
		background: #FF8A24;
		border-radius: 6px 6px 6px 6px;
		padding: 0 38px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 42px;
		margin: 39px 0 0 0;
	}
</style>